import React, { Component } from 'react'
import Appdirect from '../app/RequestValidator.js'
import Spinner from '../app/Spinner.js'
import PropTypes from 'prop-types'
import { WindowSizeContext, breakpoints } from '../app/windowSize.js'
import isEmpty from 'lodash/isEmpty'
import Menu from '../components/menu.js'
import ErrorBoundary from '../containers/pages/Error.js'
import constants from '../resource/constants.js'
import HeroIdentity from '../components/common/HeroIdentity.js'
import HeroOversizeBackgroundCircled from '../assets/images/AP-Pilot-Hero-Oversize-circled.png'

const $ = window.$ || {
    on: () => {
    },
}

const cb = window.cb || {
    apricot: {
        CBUtils: {
            viewport: () => {
                console.error('CBUtils.viewport is not available')
                return {}
            },
        },
        CBModal: {
            init: () => {
                console.error('CBModal is not available')
            }
        }
    },
    core: {
        iam: {
            events: {
                Login: () => {
                },
                Logout: () => {
                },
            },
            getEventBus: () => {
                return {
                    on: () => {
                    },
                }
            },
            getAuthSession: () => {
                return {
                    isLoggedIn: false
                }
            },
        },
    },
}

const iamBus = cb.core.iam.getEventBus()

class App extends Component {
    static defaultProps = {
        appId: constants.app_id,
        isLoggedIn: cb.core.iam.getAuthSession().isLoggedIn,
    }

    windowSize = breakpoints.xs

    constructor(props) {
        super(props)

        this.state = {
            ...App.defaultProps,
            hasJWTToken: this.isJwtTokenReady(),
            data: '',
            orgId: '',
            roleCd: '',
            userName: '',
            authnToken: '',
            authzToken: '',
            error: null
        }
    }

    componentDidMount() {
        const prefix = (typeof cb.apricot.CBUtils.viewport === 'function') ? cb.apricot.CBUtils.viewport().prefix : 'xs'
        iamBus.on(cb.core.iam.events.AWSLogin, this.updateAuthState)
        iamBus.on(cb.core.iam.events.Logout, this.clearResource)
        this.windowSize = breakpoints[prefix]
        if (typeof cb.apricot.CBUtils.breakpoints === 'function') {
            cb.apricot.CBUtils.breakpoints()
        }

        if (typeof $ === 'function') {
            $(document).on('breakpoint_change', (e, data) => {
                this.windowSize = breakpoints[data.prefix]
            })
        }
        // Update the state.
        this.updateAuthState()
    }

    clearResource = () => {
        sessionStorage.clear()
    }

    isJwtTokenReady = () => {
        let jwtToken = ''
        if (typeof cb.core.iam.getJWTToken === 'function') {
            jwtToken = cb.core.iam.getJWTToken()
        }
        return !isEmpty(jwtToken)
    }

    updateAuthState = async () => {
        const prefix = (typeof cb.apricot.CBUtils.viewport === 'function') ? cb.apricot.CBUtils.viewport().prefix : 'xs'
        const hasJWTToken = this.isJwtTokenReady()
        const isLoggedIn = cb.core.iam.getAuthSession().isLoggedIn
        if (hasJWTToken) {
            this.loadLoginUser({ hasJWTToken, isLoggedIn })
        } else {
            this.setState({
                ...App.defaultProps,
                isLoggedIn,
                hasJWTToken,
            })
            this.windowSize = breakpoints[prefix]
        }
    }

    parseAuthToken = (jwtToken, userData) => {
        return new Promise(resolve => {
            const decodedToken = JSON.parse(atob(jwtToken.split('.')[1]))
            const userName = userData.basicProfile.userName
            const catapultId = decodedToken.sub
            let userId = ''
            if (catapultId.indexOf(':') !== -1) {
                userId = catapultId.split(':')[1]
            } else {
                userId = catapultId
            }
            const roleOrgsList = decodedToken.cb.ro
            let userOrgIds = [],
                data = {}
            if (!isEmpty(roleOrgsList)) {
                roleOrgsList.forEach(pair => {
                    if (pair.rid === '805') {
                        userOrgIds.push(pair.oid)
                    }
                })
                data = {
                    // orgId is picked from the first item of the list - "orgId": roleOrgsList[0].oid,
                    'userOrgIds': userOrgIds,
                    "cognitoId": userId,
                    "userName": userName,
                    "authzToken": cb.core.iam.getAuthorizationToken(),
                    "authnToken": cb.core.iam.getAuthenticationToken()
                }
            } else {
                data = {
                    "cognitoId": userId,
                    "userName": userName,
                    "authzToken": cb.core.iam.getAuthorizationToken(),
                    "authnToken": cb.core.iam.getAuthenticationToken()
                }
            }
            sessionStorage.setItem('authSession', JSON.stringify(data))
            resolve(data)
        })
    }

    loadLoginUser = async (customProps, orgEvent) => {
        const prefix = (typeof cb.apricot.CBUtils.viewport === 'function') ? cb.apricot.CBUtils.viewport().prefix : 'xs'
        try {
            let authValues = await this.parseAuthToken(cb.core.iam.getJWTToken(), cb.core.iam.getAuthSession())
            sessionStorage.setItem('orgEvent', JSON.stringify(orgEvent))
            this.setState({
                ...customProps,
                data: {
                    // orgId: authValues.orgId,
                    userOrgIds: authValues.userOrgIds,
                    roleCd: authValues.cognitoId,
                    userName: authValues.userName,
                    authzToken: authValues.authzToken,
                    authnToken: authValues.authnToken
                },
            })
            this.render()
        } catch (error) {
            console.log(error)
        }
        if (this.props.updateUser) {
            await this.props.updateUser({
                variables: {
                    input: {
                        lastLogonDatetime: new Date(),
                    }
                }
            })
        }
        this.windowSize = breakpoints[prefix]
    }

    componentDidCatch(error) {
        this.setState({ error })
    }

    render() {
        var Data = this.state.data
        const { origin, pathname } = window.location
        const {
            appId,
            isLoggedIn,
            hasJWTToken,
        } = this.state
        return !isLoggedIn ? (
            <HeroIdentity
                appId={appId}
                redirectUrl={`${origin}${pathname}`}
                heroContentText="Log into AP Test Center Enrollment"
                identityDesc="Sign in to your CollegeBoard account"
                heroBackgroundImageUrl={HeroOversizeBackgroundCircled}
            />
        ) : !hasJWTToken ? (
            <div className="container">
                <Spinner />
            </div>
        ) : (
            <div>
                <ErrorBoundary>
                    <Menu />
                    <WindowSizeContext.Provider value={this.windowSize}>
                        <Appdirect UserAssociatedOrgs={Data} />
                    </WindowSizeContext.Provider>
                </ErrorBoundary>
            </div>
        )
    }
}

App.propTypes = {
    appId: PropTypes.string,
    updateUser: PropTypes.func,
}
export default App
